import React, { useEffect, useState } from "react";
import ImagesSlider from "../../ImagesSlider";
import CronometerCounter from "../../CronometerCounter";
import ActionButton from "../../ActionButton";
import { useNavigate } from "react-router";
import axios from "../../../axios/axios";
import NetaqInput from "../../NetaqInput";
import FileUpload from "../../FileUpload";
import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from "../../TranslationText";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../Loader";
import { formatDate } from "../../../helper/formatDate";
import { convertToCamelCase } from "../../../helper/convertToCamelCase";
import { FetchBankDetailsthunk } from "../../../Redux/LookUp/LookUpAction";
import { Link } from "react-router-dom";
import { CompareDate } from "../../../helper/CompareDate";
import Popup from "reactjs-popup";
import { formatDateTimeInArabic } from "../../../helper/formateDateTimeToArabic";
import PillBtn from "../../PillBtn";
import EahsForm from "../../EahsForm";
import { aedLogoStyle, btnContainerShow, getDirhamImage, iconContainer, pageTitleShow, serviceRequestHeadContainer, showIconsContainer } from "../../../common/cssclasses";
import CustomPopUp from "../../CustomPopUp";
import CustomSecondPopUp from "../../CustomSecondPopUp";
import { formatDateTimeToString } from "../../../helper/formatDateTimeToString";
import { formatFee } from "../../../helper/formatFee";


// import { useLocation } from 'react-router-dom';

const styles = {
  // TimerContainer: {
  //   width: "80%",
  //   marginLeft: -20,
  //   paddingLeft: 30,
  // },
  // TimerIconContainer: { padding: "20px 0" },
  TimerIcon: { color: "var(--mainGold)", },
};

const BaseURL = process.env.REACT_APP_BASE_URL;

const AuctionTimer = ({ startDate, endDate, auctionTimer }) => {
  const [label, setLabel] = useState("Starts in");
  const [targetDate, setTargetDate] = useState(new Date());
  const [counterDirection, setCounterDirection] = useState(false);
  const { translate } = useTranslate();
  const tt = auctionTimer;

  useEffect(() => {
    const firstDate =
      startDate?.constructor === Date ? startDate : new Date(startDate);
    const secondDate =
      endDate?.constructor === Date ? endDate : new Date(endDate);

    if (firstDate > new Date()) {
      setLabel("Start in:");
      setTargetDate(firstDate);
      setCounterDirection(false);
    } else if (secondDate > new Date()) {
      setLabel("Ends at:");
      setTargetDate(secondDate);
      setCounterDirection(false);
    } else {
      setLabel("Timed out since:");
      setTargetDate(secondDate);
      setCounterDirection(true);
    }
  }, [startDate, endDate]);

  return (
    <>
      <div
        className="text-start "
      >
        <i className=" fa-regular fa-clock C89C66  fw-bold " ></i>

        <div
          className="text-start d-inline-block"
        >
          <span className="mx-2">{translate(`web.${convertToCamelCase(label)}`, label)}</span>

          <CronometerCounter endDate={targetDate} countUp={counterDirection} className="d-inline-block C89C66" />
        </div>
      </div>
    </>
  );
};

/**
 * Auction Header Component
 * @param {*} slider
 * @param {*} details
 * @returns JSX Component element
 */
export default function AuctionHeader({ slider, details, paymentStatus, getPaymentStatus, auctionHorses, bidderNumber, bidderId }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const { bankDetailsData } = useSelector((state) => state.lookUpSlice);

  const { translate } = useTranslate();
  const dismissAll = () => toast.dismiss();
  const [isBidForOthers, setIsBidForOthers] = useState(false);

  const {
    auctionName: name,
    auctionType: type,
    auctionStartDate: startDate,
    auctionTimer: auctionTimer,
    auctionEndDate: endDate,
    auctionNumberOfHorses: horsesCount,
    auuctionId: auctionID,
    auctionFees,
  } = details;

  // console.log("details", details);
  // const location = useLocation();

  // Accessing the current URL including all queries
  // const currentURL = location.href + location.search;
  const currentURL = window.location.href;

  const accessToken = localStorage.getItem("accessTokenforEAHS");
  const [userProfile, setUserProfile] = useState({
    "Full Name": "",
    Nationality: "",
    Address: "",
    "Phone Number": "",
    "Emirates ID": "",
  });
  const [showAuctionPaymentConfirmation, setAuctionPaymentConfirmation] =
    useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [paymentConfirmation, setPaymentConfirmation] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [enrollButtonText, setEnrollButtonText] = useState(
    translate("web.enrollNow", "Enroll Now")
  );
  const [showEnrollBtn, setShowEnrollBtn] = useState(true);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loader, setLoader] = useState(false);
  const [uploadBankTransfer, setUploadBankTransfer] = useState(null);

  const handleFilesUploaded = (e) => {
    let checkFileSize = true;
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        checkFileSize = false;
      } else {
        if (e.target.files && e.target.files.length > 0) {
          setUploadBankTransfer({
            file: URL.createObjectURL(e.target.files[0]),
            name: e.target.files[0].name,
          });

          setUploadedFiles(e.target.files[0]);
        }
      }
    }

    if (!checkFileSize) {
      toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
    }
  };

  async function handelEnrollment(pressed = true) {
    try {
      if (accessToken != null && accessToken !== "") {
        const userProfile = await axios.get("/account/profile");
        const formattedData = {
          "Full Name": userProfile.data.result.fullName,
          Nationality: userProfile.data.result.nationalityName,
          Address: userProfile.data.result.address,
          "Phone Number": userProfile.data.result.phone,
          "Emirates ID": userProfile.data.result.idNumber,
        };
        setUserProfile(formattedData);

        const userID = localStorage.getItem("EAHSUserID");
        const response = await axios.get(
          `./bidders/isauctionuserenrolled?userId=${userID}&auctionId=${auctionID}`
        );
        if (response.data.status.responseCode === "100") {
          // console.log("enrollment status is", response);
          setEnrollButtonText(translate("web.enrollNow", "Enroll Now"));
          if (pressed) {
            setAuctionPaymentConfirmation(true);
          }
          getPaymentStatus("PendingPayment");
        } else {
          if (pressed) {
            setAuctionPaymentConfirmation(true);
          }
          getPaymentStatus(
            response.data.result.paymentStatus,
            response.data.result.bidderId,
            response.data.result.bidderNumber
          );
          if (response.data.result.paymentStatus === "PendingPayment") {
            setEnrollButtonText(
              translate("web.completePayment", "Complete Payment")
            );
          }
          if (response.data.result.paymentStatus !== "PendingPayment") {
            // console.log("payment Status??", response.data.result.paymentStatus);
            setShowEnrollBtn(false);
          }
        }
        // console.log(" ", response);
      } else {
        if (pressed) {
          navigate(`/login?redirectURL=/singleauction?id=${auctionID}`);
        }
        getPaymentStatus("");
      }
    } catch (error) {
      // console.log("error in handle enrolment", error);
    }
  }

  async function closepaymentconfirmation() {
    setAuctionPaymentConfirmation(false);
  }

  const handleCheckboxChange = (e) => {
    setAcceptTerms(e.target.checked);
  };

  async function confirmAndPayNow() {
    setPaymentConfirmation(true);
    setAuctionPaymentConfirmation(false);
  }
  const handleExternalLink = (url) => {
    window.location.href = url + `&returnUrl=${currentURL}`; // Opens the URL in a new tab
  };

  async function makePayment(paymentType = paymentMethod) {
    const userID = localStorage.getItem("EAHSUserID");
    setLoader(true);
    try {
      switch (paymentType) {
        case "onlinepayment":
          const payment = await axios.post(
            "/bidders/enrollbidder",
            {
              UserId: userID,
              EnrolledAuctionId: auctionID,
              DepositPayment: "EnrollWithPayment",
              PaymentStatus: "Paid",
              PaymentMethod: "OnlinePayment",
              BidderFiles: "",
              IsBidForOthers: isBidForOthers
            },
            {
              headers: {
                "content-type": "multipart/form-data",
              },
            }
          );
          const paymentURL = payment.data.result.url;

          setLoader(false);
          if (payment.data.status.responseCode === "200") {
            handleExternalLink(paymentURL);
            // console.log("payment is ", payment.data);
          } else if (payment.data.status.responseCode === "100") {
            toast.error(translate(`web.${payment.data?.result}`, payment.data?.result));
          }

          //TODO: Complete Payment flow
          /**
           * setPaymentConfirmation(false)
           *  */

          break;
        case "banktransfer":
          const bankpayment = await axios.post(
            "/bidders/enrollbidder",
            {
              UserId: userID,
              EnrolledAuctionId: auctionID,
              DepositPayment: "EnrollWithPayment",
              PaymentStatus: "Paid",
              PaymentMethod: "BankTransfer",
              BidderFiles: uploadedFiles,
              IsBidForOthers: isBidForOthers
              //BidderFiles: uploadedFiles[0],
            },
            {
              headers: {
                "content-type": "multipart/form-data",
              },
            }
          );
          setLoader(false);
          if (bankpayment.data.status.responseCode === "200") {
            // console.log("bankpayment is ", bankpayment.data);
            toast.success(
              translate(
                "web.bankTransfer",
                "it may take up to 3 working days to completed "
              )
            );
            setPaymentConfirmation(false);
          }
          break;
        case "cash":
          const cashpayment = await axios.post(
            "/bidders/enrollbidder",
            {
              UserId: userID,
              EnrolledAuctionId: auctionID,
              DepositPayment: "EnrollWithPayment",
              PaymentStatus: "Paid",
              PaymentMethod: "Cash",
              IsBidForOthers: isBidForOthers,
              BidderFiles: "",
            },
            {
              headers: {
                "content-type": "multipart/form-data",
              },
            }
          );
          setLoader(false);
          if (cashpayment.data.status.responseCode === "200") {
            toast.success(
              translate(
                "web.cashEnrollMsg",
                "Please Proceed to complete the payment at EAHS office "
              )
            );
            setPaymentConfirmation(false);
          }
          break;

        default:
          toast.error(
            translate(
              "web.pleaseSelectPaymentMethod",
              "Please select payment method"
            )
          );
          break;
      }
    } catch (error) {
      setLoader(false);
      toast.error(translate('web.errorInMakePaymentPleaseContactAdmin', 'error in make payment Please Contact Admin'))
    }
  }

  // check the auction end date 3 days
  const threeDaysAgo = new Date(endDate);
  threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);
  const currentDate = new Date();

  // endDate > now + 3

  // Compare the dates
  const isBeforeThreeDays = currentDate < threeDaysAgo;

  useEffect(() => {
    handelEnrollment(false);
  }, [auctionID]);

  useEffect(() => {
    dispatch(FetchBankDetailsthunk());
  }, []);





  return (
    <>
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />
      <div className={serviceRequestHeadContainer}>
        <h2 className={pageTitleShow}>
          {name}
        </h2>

        <div className={btnContainerShow} >
          {showEnrollBtn && details.isEnrollOpened == true && new Date(endDate) > new Date() && (
            <PillBtn
              isSubmitBtn
              isWithClass
              isNoMargin
              classes="btn-secondary mb-2"
              isNoAction={true}
              text={enrollButtonText}
              onClick={handelEnrollment}
            />
          )}
          {!!details?.eventId &&
            <PillBtn
              isNoMargin
              routeName={`/book-table?eventid=${details.eventId}`}
              isRed={true}
              text={translate('web.bookTable', 'Book Table')}
            />
          }
          {details?.isAuctionLive && details?.isAuctionedOneByOne &&
            <PillBtn
              isNoMargin
              text={translate("web.watchNow", "Watch Now")}
              isRed={true}
              routeName={"/hybridBidding?auctionID=" + details.auuctionId}
            />
          }
        </div>
        <div className={showIconsContainer}>
          {!!startDate && (
            <div className={iconContainer} >
              <i
                className="fa fa-calendar C89C66"
              ></i>
              <span>{formatDateTimeToString(startDate,'',true)}</span>
            </div>
          )}
          {!!endDate && (
            <div className={iconContainer} >
              <i
                className="fa fa-calendar C89C66"
              ></i>
              <span>{formatDateTimeToString(endDate,'',true)}</span>
            </div>
          )}

          <div className={iconContainer} >
            <i className=" fa fa-gavel C89C66"></i>
            <span>
              {translate(
                `web.${details?.auctionType.toLowerCase()}`,
                details?.auctionType
              )}
            </span>
          </div>
          <div className={iconContainer} >
            <img src={getDirhamImage(currentLanguage)} alt="AED" style={aedLogoStyle} />
            <span>
              {formatFee(details?.auctionFees, translate, currentLanguage)}
            </span>
          </div>

          {!!horsesCount && (
            <div className={iconContainer} >
              <i
                className="fa-solid fa-chess-knight C89C66"
              ></i>
              <span>{horsesCount} {horsesCount > 1 ? <>{translate('web.horses', 'Horses')}</> : <>{translate('web.horse', 'Horse')}</>}</span>
            </div>
          )}
          {!!endDate && new Date(endDate) > new Date() && (
            <div className={iconContainer}>
              {new Date(endDate) > new Date() && (
                <AuctionTimer auctionTimer={auctionTimer} startDate={startDate} endDate={endDate} />
              )}
            </div>
          )}

        </div>


        <CustomSecondPopUp
          open={showAuctionPaymentConfirmation}
          title={translate("web.enrollment", "Enrollment") + " - " + details.auctionName}
          btnText={translate(
            "web.confirmAndPayNow",
            "Confirm & Pay Now"
          )}
          onSave={() => makePayment('onlinepayment')}
          onClose={closepaymentconfirmation}
          isDisabled={!acceptTerms}

        >
          <div className="text-start mb-main">
            <h4 className="red fw-bold">
              {translate("web.auctionFees", "Auction Fees")}:{" "}
              {formatFee(auctionFees, translate, currentLanguage)}
            </h4>
          </div>

          <div className={showIconsContainer}>
            {!!userProfile['Full Name'] &&
              <div className={iconContainer}>
                <i className="fa fa-user red"></i>
                <span>{userProfile['Full Name']}</span>
              </div>
            }
            <div className={iconContainer}>
              <img src={getDirhamImage(currentLanguage)} alt="AED" style={aedLogoStyle} />
              <span>{formatFee(auctionFees, translate, currentLanguage)}</span>
            </div>
            {!!userProfile['Nationality'] &&
              <div className={iconContainer}>
                <i className="fa fa-globe-americas red"></i>
                <span>{userProfile['Nationality']}</span>
              </div>
            }
            {!!userProfile['Address'] &&
              <div className={iconContainer}>
                <i className="fa-solid fa-location-dot red"></i>
                <span>{userProfile['Address']}</span>
              </div>
            }
            {!!userProfile['Phone Number'] &&
              <div className={iconContainer}>
                <i className="fa-solid fa-phone red"></i>
                <span>{userProfile['Phone Number']}</span>
              </div>
            }
            {!!userProfile['Emirates ID'] &&
              <div className={iconContainer}>
                <i className="fa-solid fa-id-card red"></i>
                <span>{userProfile['Emirates ID']}</span>
              </div>
            }

          </div>


          <NetaqInput
            key={'participateforOthers'}
            name='participateforOthers'
            type="checkbox"
            label={translate(
              "web.isBidForOthers",
              "Is Bid For Others"
            )}
            value="accepted"
            checked={isBidForOthers}
            onChange={(e) => setIsBidForOthers(e.target.checked)}
          />
          <CustomPopUp
            title={translate('web.termsAndConditions', 'TermsAndConditions')}
            trigger={
              <NetaqInput
                key={'participateforOthers'}
                name='participateforOthers'
                type="checkbox"
                label={translate(
                  "web.iAgreeToTheTermsAndConditionsOfTheAuction",
                  "I agree to the terms and conditions of the auction"
                )}
                value="accepted"
                checked={acceptTerms}
                onChange={handleCheckboxChange}
                isLink
              />
            }
            content={<div
              className="text-start"
              dangerouslySetInnerHTML={{ __html: currentLanguage == 'en' ? details.termsAndConditionsTextEn : details.termsAndConditionsTextAr }}
            />}
          />
        </CustomSecondPopUp>

        
      </div >
      <div className="row">
        <div className="col-xl-8 col-lg-8 col-md-12 mb-main">
          <div className="bg-white p-main border-15 p-3 h-100">
            <ImagesSlider
              data={slider}
              sliderName={"auctionSlider"}
              type={"auctionSlider"}
              VideoURL={[details.liveUrl, details.introVideoUrl]}
            />
          </div>
        </div>
        <div className="col-xl-4 col-lg-4 col-md-12 mb-main">
          <div className="bg-white p-main border-15 p-3 h-100 ">
            {(!!details?.inspectionStartDate || !!details?.inspectionEndDate) &&
              <>
                <div className="mb-form-group">
                  <label className="bold rtl capatalise">
                    {translate("web.horsesViewDates", "Horses View Dates")}
                  </label>
                  <div className="col-12">
                    <AuctionDates
                      date={details.inspectionStartDate}
                      isWithLabel={false}
                      currentLanguage={currentLanguage}
                    />
                  </div>
                  <div className="col-12">
                    <AuctionDates
                      date={details.inspectionEndDate}
                      isWithLabel={false}
                      currentLanguage={currentLanguage}
                    />
                  </div>
                </div>
              </>
            }
            {(!!details?.reservedBidNoStartDate || !!details?.reservedBidNoEndDate) &&

              <div className="mb-form-group">
                <label className="bold rtl capatalise">
                  {translate("web.reservedDates", "Reserved Dates")}
                </label>
                <div className="col-12" style={{ width: 'unset' }}>
                  <AuctionDates
                    date={details.reservedBidNoStartDate}
                    isWithLabel={false}
                    currentLanguage={currentLanguage}
                  />
                </div>
                <div className="col-12" style={{ width: 'unset' }}>
                  <AuctionDates
                    date={details.reservedBidNoEndDate}
                    isWithLabel={false}
                    currentLanguage={currentLanguage}
                  />
                </div>
              </div>
            }

            {paymentStatus !== "" && (
              <div className="mb-form-group">
                <label className="bold rtl capatalise">
                  {translate("web.paymentStatus", "Payment Status")}:
                </label>
                <div className="col-12">
                  {paymentStatus !== ""
                    ? translate(
                      `web.${paymentStatus.toLowerCase()}`,
                      paymentStatus
                    )
                    : ""}
                </div>
              </div>
            )}
            <div className="mb-form-group">
              <label className="bold rtl capatalise">
                {translate("web.auctionDetails", "Auction Details")}
              </label>
              {!!details.location &&
                <div className="col-12">
                  <i className=" fa-solid fa-location-dot C89C66" ></i>
                  <span>
                    <Link
                      target="_blank"
                      to={details.location}
                      className="C89C66"
                    >
                      {translate("web.showonGoogleMaps", "Show on Google Maps")}
                    </Link>
                  </span>
                </div>
              }
              {(
                <>
                  <CustomPopUp
                    trigger={
                      <div key={'iFileItem'} className="col-12" style={{ cursor: 'pointer', }}>
                        <i className=" fa-solid fa-file C89C66" ></i>
                        <span className="C89C66">
                          {translate(
                            "web.showTermsandConditions",
                            "Show Terms and Conditions"
                          )}
                        </span>
                      </div>
                    }
                    title={translate('web.termsAndConditions', 'terms And Conditions')}
                    content={
                      <div
                        className="text-start"
                        dangerouslySetInnerHTML={{ __html: currentLanguage == 'en' ? details.termsAndConditionsTextEn : details.termsAndConditionsTextAr }}
                      />
                    }
                  />
                </>
              )}
            </div>
          </div>

        </div>
      </div >
    </>
  );
  function AuctionDates({ date, label = "label", isWithLabel = true, currentLanguage = 'en' }) {
    if (isWithLabel == false) {
      return (
        <>
          {!!date &&
            <>
              <i className=" fa fa-calendar C89C66" ></i>
              <span>
                {formatDateTimeInArabic(date, currentLanguage)}
              </span>
            </>
          }
        </>
      )
    }
    else {
      return (
        <>
          {!!date &&
            <div className="AuctionDatesStyle">
              <div>
                <i className="fa-solid fa-calendar C89C66"></i>
                <span className="">{translate(`web.${label}`, label)}</span>
              </div>
              <div className="rtl">
                <span className="C89C66">
                  {formatDateTimeInArabic(date, currentLanguage)}
                </span>
              </div>
            </div>
          }
        </>
      );
    }
  }
}

export { AuctionTimer };
